export const GUEST = {
  ORDERS: 'guest_orders',
  UPGRADE: 'guest_upgrade',
  UPGRADE_RESEND_LINK: 'guest_upgrade_resend_link',
}
